/**
 * 답변을 Word / PowerPoint / Excel로 다운로드
 */
import { ephemeralAPI } from '../services/api';

export async function downloadExportedFile(format, payload) {
  const res = await ephemeralAPI.exportAnswer({ format, ...payload });
  const disposition = res.headers?.['content-disposition'] || '';
  const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)/i);
  const filename = match
    ? decodeURIComponent(match[1])
    : `koai-answer.${format}`;

  const blob = new Blob([res.data], { type: res.headers?.['content-type'] });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function getExportErrorMessage(err, fallback = '파일 저장에 실패했습니다.') {
  let message = fallback;
  const data = err.response?.data;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      const parsed = JSON.parse(text);
      message = parsed.error || message;
    } catch {
      message = err.message || message;
    }
  } else if (typeof data?.error === 'string') {
    message = data.error;
  } else if (err.message) {
    message = err.message;
  }
  return message;
}
